import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";

const CookieSettingsButton = ({ className = "", variant = "default" }) => {
  const { t } = useTranslation();

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("openCookieSettings"));
    }
  };

  const variantClass =
    variant === "compact"
      ? "cookie_settings_button--compact"
      : "cookie_settings_button--default";

  const combinedClassName = `cookie_settings_button ${variantClass} ${className}`.trim();

  return (
    <button type="button" className={combinedClassName} onClick={handleClick}>
      {t("cookie_settings")}
    </button>
  );
};

export default CookieSettingsButton;

